import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-rows: repeat(1, auto) minmax(0, 1fr);
        height: 100%;
        gap: ${spacing * 2}px;
    `
)

export const StyledPageHeading = styled(Flexbox)(
    ({theme: {palette}}) => css`
        background-color: ${palette.neutral['white']};
        border-radius: 0 0 8px 8px;
        border: 1px solid ${palette.neutral[200]};
        border-top: none;
    `
)

export const StyledAccessesValidatorListItemSkeletonContainer = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: grid;
        padding: ${spacing * 4}px ${spacing * 6}px;
        grid-template-columns: auto repeat(2, 1fr) 60px repeat(4, 1fr) auto;
        gap: ${spacing * 4}px;
        align-items: center;
        border: 1px solid ${palette.neutral['200']};
        background-color: ${palette.neutral['white']};
        border-radius: ${spacing * 2}px;
    `
)
